import React, { useEffect, useState } from 'react';
import {
  TextInput,
  Text,
  View,
  StyleSheet,
  Pressable,
  Image,
} from 'react-native';
import { useNavigate } from 'react-router-dom';

import { register } from 'data/user';

const loadingIcon = require('assets/loading.gif');

export function Register() {
  const [loginData, setLoginData] = useState({
    username: '',
    password: '',
    name: '',
    registerKey: '',
  });
  const [disabled, setDisabled] = useState(true);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  function validPassword(password) {
    const regex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
    return regex.test(password);
  }

  function onChangeText(val, key) {
    setLoginData({ ...loginData, [key]: val });
    setError(null);
  }

  useEffect(() => {
    if (
      !loginData.username ||
      !validPassword(loginData.password) ||
      !loginData.name ||
      !loginData.registerKey
    ) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [loginData]);

  function submit() {
    setError(null);
    setLoading(true);
    register(loginData)
      .then(() => {
        setLoading(false);
        return navigate('/admin');
      })
      .catch((err) => {
        setLoading(false);
        if (err.error === 'User already exists') {
          setError('Username already exists, please choose another one.');
        } else {
          setError('An error has occurred, please try again.');
        }
      });
  }

  return (
    <View style={style.container}>
      <Text style={style.title}>Registration</Text>
      <View>
        <Text style={style.label}>Name:</Text>
        <TextInput
          onChangeText={(val) => onChangeText(val, 'name')}
          style={style.input}
          value={loginData.name}
        />

        <Text style={style.label}>User name:</Text>
        <TextInput
          onChangeText={(val) => onChangeText(val, 'username')}
          style={style.input}
          value={loginData.username}
        />

        <Text style={style.label}>Password:</Text>
        <TextInput
          onChangeText={(val) => onChangeText(val, 'password')}
          style={style.input}
          value={loginData.password}
          secureTextEntry={true}
        />
        <Text style={style.instruction}>
          Must be at least 8 characters including upper and lowercase, and at
          least one number and one special character.
        </Text>

        <Text style={style.label}>Registration ID:</Text>
        <TextInput
          onChangeText={(val) => onChangeText(val, 'registerKey')}
          style={style.input}
          value={loginData.registerKey}
          secureTextEntry={true}
        />

        {error && <Text style={style.error}>{error}</Text>}

        {loading ? (
          <Pressable style={[style.button, style.disabled]}>
            <Image source={loadingIcon} style={style.loadingImage} />
          </Pressable>
        ) : (
          <Pressable
            onPress={submit}
            style={[style.button, disabled ? style.disabled : null]}
            disabled={disabled}
          >
            <Text style={style.buttonText}>Register</Text>
          </Pressable>
        )}
      </View>
    </View>
  );
}

const style = StyleSheet.create({
  container: {
    maxWidth: 700,
    flex: 1,
    justifyContent: 'center',
    padding: 20,
  },
  title: {
    fontSize: 24,
    marginBottom: 20,
    fontWeight: 'bold',
  },
  input: {
    borderWidth: 1,
    borderColor: 'grey',
    padding: 5,
    borderRadius: 0,
    marginBottom: 10,
  },
  success: {
    color: '#008000',
  },
  error: {
    color: '#e43333',
    fontWeight: 'bold',
    marginBottom: 10,
    fontSize: 18,
  },
  inputError: {
    borderColor: '#e43333',
    marginBottom: 0,
  },
  label: {
    fontSize: 18,
    marginBottom: 5,
  },
  button: {
    backgroundColor: '#152B61',
    alignSelf: 'flex-start',
    padding: 5,
  },
  buttonText: {
    color: '#fff',
    fontWeight: 'bold',
    padding: 5,
    fontSize: 16,
  },
  disabled: {
    opacity: 0.5,
  },
  loadingImage: {
    width: 30,
    height: 30,
  },
  instruction: {
    marginBottom: 10,
  },
});
